import magnifiAPIInstance from "./apiInstance";

export const fieldsAPIs = {
  getCoreFields: ({ payload }) => magnifiAPIInstance.get("/api/v3/fields/core", payload),
  addCoreField: ({ payload }) => magnifiAPIInstance.post("/api/v3/fields/core", payload),
  updateCoreField: ({ id, payload }) => magnifiAPIInstance.put(`/api/v3/fields/core/${id}`, payload),
  getOrganizationCustomFields: ({ entityId, payload }) =>
    magnifiAPIInstance.get(`api/v3/org-fields/${entityId}`, payload),
};
